import { TierName } from '../contexts/AuthContext';

export const TIER_THRESHOLDS = {
  watcher: 1_000_000,
  deep_diver: 15_000_000,
} as const;

export const SUBSCRIPTION_PRICES = {
  watcher: 10,      // $10/month
  deep_diver: 150,  // $150/month
} as const;

export const DNET_DEX_URL = 'https://jup.ag/tokens/93VXFhKsGXsraivwdwAwoVXHKd4U1TFL64oQYpVjpump';

export function getTierLabel(tier: TierName): string {
  switch (tier) {
    case 'deep_diver': return 'Deep Diver';
    case 'watcher': return 'Watcher';
    default: return 'Free';
  }
}

export function getTierColor(tier: TierName): string {
  switch (tier) {
    case 'deep_diver': return 'text-purple-400';
    case 'watcher': return 'text-crypto-accent';
    default: return 'text-gray-400';
  }
}

export function getTierBgColor(tier: TierName): string {
  switch (tier) {
    case 'deep_diver': return 'bg-purple-500/10 border-purple-500/30';
    case 'watcher': return 'bg-crypto-accent/10 border-crypto-accent/30';
    default: return 'bg-gray-500/10 border-gray-500/30';
  }
}

export function getTierIcon(tier: TierName): string {
  switch (tier) {
    case 'deep_diver': return '🔱';
    case 'watcher': return '👁️';
    default: return '';
  }
}

export function getNextTier(tier: TierName): { name: TierName; label: string; required: number } | null {
  switch (tier) {
    case 'free': return { name: 'watcher', label: 'Watcher', required: TIER_THRESHOLDS.watcher };
    case 'watcher': return { name: 'deep_diver', label: 'Deep Diver', required: TIER_THRESHOLDS.deep_diver };
    default: return null;
  }
}

export function formatDnetAmount(amount: number): string {
  if (amount >= 1_000_000) return `${(amount / 1_000_000).toFixed(1)}M`;
  if (amount >= 1_000) return `${(amount / 1_000).toFixed(0)}K`;
  return amount.toFixed(0);
}

export function hasWatcherAccess(tier?: TierName): boolean {
  return tier === 'watcher' || tier === 'deep_diver';
}

export function hasDeepDiverAccess(tier?: TierName): boolean {
  return tier === 'deep_diver';
}
